<app-school-view></app-school-view>  
